import { apyToAprPercent } from '../../../utils/parsing'
import { YieldFetcher } from '../../types'
import { fetchDefiLlamaApy } from './defillama'

/**
 * BeraPaw LBGT — intrinsic APR.
 *
 * LBGT is a 1:1 BGT wrapper; its yield is the underlying PoL/BGT emission
 * reward rate, not a rising share price. BeraPaw exposes no consumable
 * public API (the `api.berapaw.com` cert mismatches), so we read the
 * DefiLlama LBGT pool, whose `apy` is a reward-APY percent (large and
 * volatile — driven by BGT emissions). Throws → `safeFetch` leaves it
 * undefined.
 */
const LBGT_DEFILLAMA_POOL = '9ccbebab-a66d-4b9e-bf6a-47ea1d638874'

export const lbgtFetcher: YieldFetcher = {
  label: 'LBGT',
  fetch: async () => {
    const apy = await fetchDefiLlamaApy(LBGT_DEFILLAMA_POOL)
    return { LBGT: apyToAprPercent(apy) }
  },
}
